import { useState } from "react";
import { FilterPill } from "./FilterPill";
import { FilterTabs } from "../FilterTabs/FilterTabs";
import { FilterValue, GroupFilter } from "../../types/filter";
import { TrackingProps } from "../../types/component";

interface PillGroupProps {
  filter: GroupFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  tracking: TrackingProps;
}

export const PillGroup = ({
  filter,
  filterValues,
  setFilterValues,
  tracking,
}: PillGroupProps) => {
  const [listBoxIsOpen, setListBoxIsOpen] = useState(false);
  return (
    <FilterPill
      filter={filter}
      listBoxIsOpen={listBoxIsOpen}
      setListBoxIsOpen={setListBoxIsOpen}
      tracking={{
        ...tracking,
        name: "group_pill",
      }}
    >
      <FilterTabs
        filter={filter}
        filterValues={filterValues}
        setFilterValues={(filterValues) => {
          setFilterValues(filterValues);
        }}
      />
    </FilterPill>
  );
};
